import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router'
import WidgetsStripeForm from './form'
import {logAnalytics, EVENT_TYPES} from 'logAnalytics'
import { Elements, useStripe, useElements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"

const stripePromise = loadStripe(process.env['REACT_APP_STRIPE_PUBLIC_KEY'])

function StripeInjectedForm(props) {
    const stripe = useStripe();
    const elements = useElements();

    return (
        <WidgetsStripeForm
            stripe={stripe}
            elements={elements}
            {...props}
        />
    );
}

function WidgetsStripe(props) {
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
        document.title = 'Math Makers'

        logAnalytics(EVENT_TYPES.PAGE_VIEW, {page: document.title})

        setMounted(true)
    }, [])

    if (!mounted)
        return <></>


    return (
        <>
            <div className='hero-bg'>
                <Elements stripe={stripePromise}>
                    <div>
                        <StripeInjectedForm />
                    </div>
                </Elements>
            </div>
        </>
    )
}

export default withRouter(WidgetsStripe)